import { LoaderFunctionArgs } from 'react-router-dom'
import { protectedLoader } from './protectLoader'
import { PORTAL_ADMIN, PORTAL_SUPPORT, SPONSOR } from '.'
import { lazyRoute } from '../utils/lazyRoute'

const sponsorRoutes = [
  {
    path: '/sponsors',
    lazy: lazyRoute(() => import('../pages/Portal/Sponsors')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [PORTAL_ADMIN, PORTAL_SUPPORT],
      }),
  },
  {
    path: '/sponsors/:sponsorId/licenses/',
    lazy: lazyRoute(
      () => import('../pages/Portal/Sponsors/components/SponsorLicenses'),
    ),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [PORTAL_ADMIN, PORTAL_SUPPORT],
      }),
  },
  {
    path: '/sponsors/overview/:sponsorId',
    lazy: lazyRoute(
      () => import('../pages/Portal/Sponsors/components/SponsorDetails'),
    ),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [PORTAL_ADMIN, PORTAL_SUPPORT, SPONSOR],
      }),
  },
  {
    path: '/dashboard/sponsors/:sponsorId/customer-dashboard/:customerId',
    lazy: lazyRoute(
      () => import('../pages/Portal/Sponsors/components/SponsorDashboard'),
    ),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [PORTAL_ADMIN, PORTAL_SUPPORT, SPONSOR],
      }),
  },
  {
    path: '/sponsors/:sponsorId/assign-licenses',
    lazy: lazyRoute(
      () => import('../pages/Portal/Sponsors/components/SponsorAssignLicenses'),
    ),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [PORTAL_ADMIN, PORTAL_SUPPORT],
      }),
  },
]

export default sponsorRoutes
